import * as Y from 'yjs';

// src/document/yjs.ts
function markNameFromAttr(key) {
  const i = key.indexOf("--");
  return i < 0 ? key : key.slice(0, i);
}
function marksToAttributes(marks) {
  const out = {};
  for (const m of marks ?? []) out[m.type] = m.attrs ?? {};
  return out;
}
function attributesToMarks(attrs) {
  if (!attrs) return [];
  const marks = [];
  for (const key of Object.keys(attrs)) {
    const value = attrs[key];
    if (value === null || value === void 0 || value === false) continue;
    const mark = { type: markNameFromAttr(key) };
    if (typeof value === "object" && Object.keys(value).length > 0) {
      mark.attrs = { ...value };
    }
    marks.push(mark);
  }
  return marks;
}
function pmContentToY(content) {
  const out = [];
  let run = [];
  const flush = () => {
    if (run.length === 0) return;
    const text = new Y.XmlText();
    text.applyDelta(
      run.map((n) => ({ insert: n.text ?? "", attributes: marksToAttributes(n.marks) }))
    );
    out.push(text);
    run = [];
  };
  for (const node of content ?? []) {
    if (node.type === "text") {
      if (node.text) run.push(node);
    } else {
      flush();
      out.push(pmNodeToY(node));
    }
  }
  flush();
  return out;
}
function pmNodeToY(node) {
  if (node.type === "text") throw new TypeError("text nodes are converted with pmContentToY");
  const el = new Y.XmlElement(node.type);
  for (const [key, value] of Object.entries(node.attrs ?? {})) {
    if (value !== null && value !== void 0) el.setAttribute(key, value);
  }
  const children = pmContentToY(node.content);
  if (children.length > 0) el.insert(0, children);
  return el;
}
function yTextToPM(text) {
  const out = [];
  for (const d of text.toDelta()) {
    if (typeof d.insert !== "string" || d.insert.length === 0) continue;
    const node = { type: "text", text: d.insert };
    const marks = attributesToMarks(d.attributes);
    if (marks.length > 0) node.marks = marks;
    out.push(node);
  }
  return out;
}
function yChildrenToPM(children) {
  const out = [];
  for (const child of children) {
    if (child instanceof Y.XmlText) out.push(...yTextToPM(child));
    else out.push(yElementToPM(child));
  }
  return out;
}
function yElementToPM(el) {
  const node = { type: el.nodeName };
  const attrs = el.getAttributes();
  if (Object.keys(attrs).length > 0) node.attrs = { ...attrs };
  const content = yChildrenToPM(el.toArray());
  if (content.length > 0) node.content = content;
  return node;
}
function yFragmentToPM(fragment) {
  return { type: "doc", content: yChildrenToPM(fragment.toArray()) };
}
function mapToObject(map) {
  return map.toJSON();
}
function writeRecord(parent, key, value) {
  let map = parent.get(key);
  if (!(map instanceof Y.Map)) {
    map = new Y.Map();
    parent.set(key, map);
  }
  const m = map;
  for (const [k, v] of Object.entries(value)) {
    if (v === void 0) continue;
    const cur = m.get(k);
    if (!jsonEqual(cur, v)) m.set(k, v);
  }
  return m;
}
function readRecord(parent, key) {
  const map = parent.get(key);
  return map instanceof Y.Map ? map.toJSON() : null;
}
function readRecords(parent) {
  const out = [];
  parent.forEach((value) => {
    if (value instanceof Y.Map) out.push(value.toJSON());
  });
  return out;
}
function jsonEqual(a, b) {
  if (a === b) return true;
  if (a instanceof Uint8Array || b instanceof Uint8Array) return false;
  if (typeof a !== "object" || typeof b !== "object" || a === null || b === null) return false;
  return JSON.stringify(a) === JSON.stringify(b);
}

export { attributesToMarks, mapToObject, markNameFromAttr, pmContentToY, pmNodeToY, readRecord, readRecords, writeRecord, yChildrenToPM, yElementToPM, yFragmentToPM, yTextToPM };
//# sourceMappingURL=chunk-TCGBD5LJ.js.map
//# sourceMappingURL=chunk-TCGBD5LJ.js.map